export default {
  title: {
    suffix: ' (stage)',
  },

  feature: {
    report: true,
  },

  invoice: {
    // 스테이징은 빌원 인보이스를 전 기간 본다. 검증용이라 가려서 볼 이유가 없다.
    billone: {
      firstMonth: null,
    },
  },
}
